var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgGraphics1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 719,
    viewBox: "0 0 1440 719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: none;\r\n        stroke-linejoin: round;\r\n        stroke-width: 30px;\r\n        opacity: 0.04;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: #cfcfaf;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #89c7aa;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #f6ae9f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(37 -120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    className: "cls-1",
    d: "M1046,539.5V481.153a30,30,0,1,1,60,0V597.847a30,30,0,1,1-60,0v-14.1",
    transform: "translate(-228 139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    className: "cls-2",
    d: "M994,451V602.829c0,45.382,36.94,82.171,82.5,82.171s82.5-36.789,82.5-82.171V566.957",
    transform: "translate(-228 139)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-2",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(1264 194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "cls-3",
    d: "M1419,311c50.81,0,92-40.518,92-90.5s-41.19-90.5-92-90.5-92,40.518-92,90.5",
    transform: "translate(-123 5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-2",
    d: "M206,406c51.915,0,94-41.413,94-92.5S257.915,221,206,221s-94,41.413-94,92.5",
    transform: "translate(-134 5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-3",
    d: "M205.5,353.51A37.256,37.256,0,1,0,168,316.255V559",
    transform: "translate(-134 5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGraphics1);
export default __webpack_public_path__ + "static/media/BG-Graphics-1.14c1f08ec27e894c6c7e97128ee558fc.svg";
export { ForwardRef as ReactComponent };